module.exports = __webpack_public_path__ + "static/media/yumiko.65bbe068.png";